import { FormGroup } from '@angular/forms';
import { Hardness } from 'src/app/tool/hardness.model';

export class Hem_ {
  public emSafety?: number;
  public plasticExp?: number;
  public elasticExp?: number;

  constructor(emSafety: number = 0.6, plasticExp: number = 1.0 / 2.0, elasticExp: number = 1.0 / 5.0) {
    this.emSafety = emSafety;
    this.plasticExp = plasticExp;
    this.elasticExp = elasticExp;
  }
}

export class Speed_ {
  public speedBar?: number;
  public feedBar?: number;

  constructor(speedBar: number = 0, feedBar: number = 0) {
    this.speedBar = speedBar;
    this.feedBar = feedBar;
  }
}

export class Parameters_ {
  public toolPath?: ToolPath | Strategy;
  public cutterDiameter?: number;
  public stickOut?: number;
  public stickoutPercentage?: number;
  public pitch?: number;
  public rampAngle?: number;
  public holeDiameter?: number;
  public pathDiameter?: number;
  public holeDepth?: number;
  public effectiveDiameter?: number;
  public chamferHeight?: number;
  public chamferWidth?: number;
  public scallopHeight?: number;
  public scallopWidth?: number;
  public cutWidth?: number;
  public cutDepth?: number;
  public stepDown?: number;
  public stepOver?: number;
  public adocdecimal?: number;
  public rdocdecimal?: number;
  public engagementAngle?: number;
  public vSliderValue?: number;
  public invalidEndmill?: boolean;

  constructor(
    toolPath: ToolPath | Strategy = undefined,
    cutterDiameter: number = 0,
    stickOut: number = 0,
    stickoutPercentage: number = 0,
    pitch: number = 0,
    rampAngle: number = 0,
    holeDiameter: number = 0,
    pathDiameter: number = 0,
    holeDepth: number = 0,
    effectiveDiameter: number = 0,
    chamferHeight: number = 0,
    chamferWidth: number = 0,
    scallopHeight: number = 0,
    scallopWidth: number = 0,
    cutWidth: number = 0,
    cutDepth: number = 0,
    stepDown: number = 0,
    stepOver: number = 0,
    adocdecimal: number = 0,
    rdocdecimal: number = 0,
    engagementAngle: number = 0,
    vSliderValue: number = 0,
    invalidEndmill: boolean = false
  ) {
    this.toolPath = toolPath;
    this.cutterDiameter = cutterDiameter;
    this.stickOut = stickOut;
    this.stickoutPercentage = stickoutPercentage;
    this.pitch = pitch;
    this.rampAngle = rampAngle;
    this.holeDiameter = holeDiameter;
    this.pathDiameter = pathDiameter;
    this.holeDepth = holeDepth;
    this.effectiveDiameter = effectiveDiameter;
    this.chamferHeight = chamferHeight;
    this.chamferWidth = chamferWidth;
    this.scallopHeight = scallopHeight;
    this.scallopWidth = scallopWidth;
    this.cutWidth = cutWidth;
    this.cutDepth = cutDepth;
    this.stepDown = stepDown;
    this.stepOver = stepOver;
    this.adocdecimal = adocdecimal;
    this.rdocdecimal = rdocdecimal;
    this.engagementAngle = engagementAngle;
    this.vSliderValue = vSliderValue;
    this.invalidEndmill = invalidEndmill;
  }
}

export class Material_ {
  // the actual material?
  public id?: number;
  public iso?: string;
  public uns?: string;
  public group?: string;
  public subGroup?: string;
  public name?: string;
  public condition?: string;
  public description?: string;
  public density?: number;
  public hardType?: string;
  public hardness?: number;
  public tensileStrength?: number;
  public yields?: number;
  public elongation?: number;
  public elasticity?: number;
  public poissons?: number;
  public thermalExpansionCoefficient?: number;
  public heat?: number;
  public thermal?: number;
  public hra?: number;
  public plasticity?: number;
  public shearFactor?: number;
  public chosenCondition?: string;
  public hrc?: number;
  public hardnessFactor?: string;
  public materialKey?: number;

  // yeild is a reserve word, had to change to yields
  constructor(
    iso: string = undefined,
    uns: string = undefined,
    group: string = undefined,
    subGroup: string = undefined,
    name: string = undefined,
    condition: string = undefined,
    description: string = undefined,
    density: number = 0,
    hardType: string = undefined,
    hardness: number,
    tensileStrength: number = 0,
    yields: number = 0,
    elongation: number = 0,
    elasticity: number = 0,
    poissons: number = 0,
    thermalExpansionCoefficient: number = 0,
    heat: number = 0,
    thermal: number = 0,
    hra: number = 0,
    plasticity: number = 0,
    shearFactor: number = 0,
    chosenCondition: string = '',
    hrc: number = 0,
    hardnessFactor: string = '',
    materialKey = undefined
  ) {
    this.iso = iso;
    this.uns = uns;
    this.group = group;
    this.subGroup = subGroup;
    this.name = name;
    this.condition = condition;
    this.description = description;
    this.density = density;
    this.hardType = hardType;
    this.hardness = hardness;
    this.tensileStrength = tensileStrength;
    this.yields = yields;
    this.elongation = elongation;
    this.elasticity = elasticity;
    this.poissons = poissons;
    this.thermalExpansionCoefficient = thermalExpansionCoefficient;
    this.heat = heat;
    this.thermal = thermal;
    this.hra = hra;
    this.plasticity = plasticity;
    this.shearFactor = shearFactor;
    this.chosenCondition = chosenCondition;
    this.hrc = hrc;
    this.hardnessFactor = hardnessFactor;
    this.materialKey = materialKey;
  }
}

export class EndMill_ {
  public id?: number = 0;
  public edp?: string = '';
  public description?: string = '';
  public coatingCode?: string = '';
  public fluteCount?: number = 0;
  public cutterDiameter?: number = 0;
  public neckDiameter?: number = 0;
  public lengthOfCut?: number = 0;
  public overallReach?: number = 0;
  public overallLength?: number = 0;
  public oal?: number = 0;
  public tipDiameter?: number = 0;
  public tip?: number = 0;
  public cornerRadius?: number = 0;
  public itemId?: number = 0;
  public pitch?: string = '';
  public rNeck?: boolean = false;
  public taper?: number = 0;
  //break is a reserve word, need to change to breaks
  public breaks?: boolean = false;
  public coreDiameter?: number = 0;
  public helix?: number = 0;
  public rake?: number = 0;
  public metricNumbers?: {
    cutterDiameter?: number;
    coreDiameter?: number; // this is calculated when tool is selected
    lengthOfCut?: number;
    overallLength?: number;
    overallReach?: number;
    neckDiameter?: number;
    tip?: number;
    cornerRadius?: number;
  };
  public searchParameter?: string;
  constructor(
    id?: number,
    edp?: string,
    description?: string,
    coatingCode?: string,
    fluteCount?: number,
    cutterDiameter?: number,
    neckDiameter?: number,
    lengthOfCut?: number,
    overallReach?: number,
    overallLength?: number,
    oal?: number,
    tipDiameter?: number,
    tip?: number,
    cornerRadius?: number,
    pitch?: boolean, // pitch comes back from backend as a boolean
    rNeck?: boolean,
    anglePerSide?: number,
    breaks?: number,
    coreDiameter?: number,
    helix?: number,
    rake?: number,
    metricNumbers?: object,
    searchParameter?: string
  ) {
    this.id = id;
    this.edp = edp;
    this.description = description;
    this.coatingCode = coatingCode;
    if (fluteCount) {
      this.fluteCount = isNaN(fluteCount) ? parseFloat(<string>fluteCount.toString()) : fluteCount;
    } else {
      this.fluteCount = 0;
    }
    this.cutterDiameter = cutterDiameter;
    this.neckDiameter = neckDiameter;
    this.lengthOfCut = lengthOfCut;
    this.overallReach = overallReach;
    this.overallLength = overallLength;
    this.oal = oal;
    this.tipDiameter = tipDiameter;
    this.tip = tip;
    this.cornerRadius = cornerRadius;
    this.rNeck = rNeck;
    this.taper = anglePerSide; //taper is anglePerSide on backend, will take anglePerSide and use as Taper on Frontend, to not change formula code
    this.breaks = breaks ? false : true; // breaks is returned as a number from backend
    this.coreDiameter = coreDiameter;
    this.helix = helix;
    this.rake = rake;
    this.metricNumbers = metricNumbers;
    this.searchParameter = searchParameter;
  }
}

export class Cutter_ extends EndMill_ {
  public catalog?: string = '';
  public series?: string = '';
  public end?: string = '';
  public lengthCategory?: string = '';
  public toolImageUrl?: string = '';
  public fluteWash?: number = 0;
  public materials?: Array<any> = [];
  public toolDetails?: Array<ToolInfo> = [];
  public materialIds?: Array<number> = [];
  public brand?: string = '';
  public brandShortName?: string = '';
  public brandKey?: number = undefined;
  public productTable?: string = '';
  public metric?: number = 0;
  public profile?: string = '';
  public includedAngle?: number = 0;
  public anglePerSide?: number = 0;
  public shankDiameter?: number = 0;

  constructor(
    id?: number,
    edp?: string,
    description?: string,
    coatingCode?: string,
    fluteCount?: number,
    cutterDiameter?: number,
    neckDiameter?: number,
    lengthOfCut?: number,
    overallReach?: number,
    overallLength?: number,
    oal?: number,
    tip?: number,
    tipDiameter?: number,
    cornerRadius?: number,
    pitch?: boolean, // pitch comes back from backend as a 0/1
    rNeck?: boolean,
    taper?: number,
    breaks?: number,
    coreDiameter?: number,
    helix?: number,
    rake?: number,
    metricNumbers?: object,
    catalog?: string,
    series?: string,
    end?: string,
    lengthCategory?: string,
    fluteWash?: number,
    materials?: Array<any>,
    brand?: string,
    brandShortName?: string,
    brandKey?: number,
    productTable?: string,
    metric?: number,
    profile?: string,
    includedAngle?: number,
    anglePerSide?: number,
    shankDiameter?: number
  ) {
    super(
      id,
      edp,
      description,
      coatingCode,
      fluteCount,
      cutterDiameter,
      neckDiameter,
      lengthOfCut,
      overallReach,
      overallLength,
      oal,
      tipDiameter,
      tip,
      cornerRadius,
      pitch,
      rNeck,
      taper,
      breaks,
      coreDiameter,
      helix,
      rake,
      metricNumbers
    );
    this.catalog = catalog;
    this.series = series;
    this.end = end;
    this.lengthCategory = lengthCategory;
    this.fluteWash = fluteWash;
    this.materials = materials;
    this.brand = brand;
    this.brandShortName = brandShortName;
    this.brandKey = brandKey;
    this.productTable = productTable;
    this.metric = metric;
    this.profile = profile;
    this.includedAngle = includedAngle;
    this.anglePerSide = anglePerSide;
    this.shankDiameter = shankDiameter;
  }
}

export interface ToolDetails {
  toolImageUrl: string;
  searchParameter: string;
  toolDetails: ToolInfo[];
}

interface ToolInfo {
  itemName: string;
  itemValue: string;
  itemUrl: string;
}

export class Machine_ {
  public spindle?: string = '';
  public holder?: string = '';
  public maxRPM?: number = 0;
  public maxIPM?: number = 0;
  public fixtureBar?: number = 0;
  public holderAdjustment?: MachineAdjustments[] = [];
  public spindleAdjustment?: MachineAdjustments[] = [];
  public dirty?: boolean = false; // mainly used for mobile to tell if user chose anything

  constructor(
    spindle?: string,
    holder?: string,
    maxRPM?: number,
    maxIPM?: number,
    fixtureBar?: number,
    holderAdjustment?: MachineAdjustments[],
    spindleAdjustment?: MachineAdjustments[],
    dirty?: boolean
  ) {
    this.spindle = spindle;
    this.holder = holder;
    this.maxRPM = maxRPM;
    this.maxIPM = maxIPM;
    this.fixtureBar = fixtureBar;
    this.holderAdjustment = holderAdjustment;
    this.spindleAdjustment = spindleAdjustment;
    this.dirty = dirty;
  }
}

export interface MachineBrandLevel {
  brandKey: number;
  mapModes: { [mapMode: number]: MachineMapModeLevel };
}

export interface MachineMapModeLevel {
  holders: MachineOptions[];
  mapMode: number;
  spindles: MachineOptions[];
}

export interface MachineOptions {
  type: string;
  name: string;
  adjustments: MachineAdjustments[];
}

export class MachineAdjustments {
  adjust: string;
  factor: number;
}

export class Machining_ {
  public feedFactor?: number = 0;
  public chipLoad?: number = 0;
  public surfaceSpeed?: number = 0;
  public baseMRR?: number = 0;

  constructor(feedFactor?: number, chipLoad?: number, surfaceSpeed?: number, baseMRR?: number) {
    this.feedFactor = feedFactor;
    this.chipLoad = chipLoad;
    this.surfaceSpeed = surfaceSpeed;
    this.baseMRR = baseMRR;
  }
}

export class Recommendation_ {
  public rpm?: number = undefined;
  public ipm?: number = undefined;
  public sfm?: number = undefined;
  public ipt?: number = undefined;
  public mrr?: number = undefined;
  public holeTime?: string = undefined;
  public chipThickness?: number = undefined;
  public insideCornerValue?: number = undefined;
  public ipmFeedInsideSlot?: number = undefined;
  public trochoidalSlotWidth?: number = undefined;
  public recommendationAdjustment?: string = '';
  public recommendationLabel?: string = '';
  public recommendationValue?: string = '';
  public speedAggression?: number = undefined;
  public feedAggression?: number = undefined;
  constructor(
    rpm?: number,
    ipm?: number,
    sfm?: number,
    ipt?: number,
    mrr?: number,
    holeTime?: string,
    chipThickness?: number,
    insideCornerValue?: number,
    ipmFeedInsideSlot?: number,
    trochoidalSlotWidth?: number,
    speedAggression?: number,
    feedAggression?: number
  ) {
    this.rpm = rpm;
    this.ipm = ipm;
    this.sfm = sfm;
    this.ipt = ipt;
    this.mrr = mrr;
    this.holeTime = holeTime;
    this.chipThickness = chipThickness;
    this.insideCornerValue = insideCornerValue;
    this.ipmFeedInsideSlot = ipmFeedInsideSlot;
    this.trochoidalSlotWidth = trochoidalSlotWidth;
    this.speedAggression = speedAggression;
    this.feedAggression = feedAggression;
  }
}

export class CurrentToolPath {
  public name: string;
  public description: string;
  public labledImage: string;
  public unLabledImage: string;
  public mapMode?: number;
  public operationKey?: number;
  public operationImage?: string;
  public operationName?: string;
  public operationToolPathDescription?: string;
  public operationToolPathTitle?: string;
  public operationImageAssetForParameterSection?: string;
  public strategies?: Strategy[];
  public toolPathId?: number;
  constructor(
    name: string,
    description: string,
    labledImage: string,
    unLabledImage: string,
    mapMode: number,
    operationKey?: number,
    operationImage?: string,
    operationName?: string,
    operationToolPathDescription?: string,
    operationToolPathTitle?: string,
    operationImageAssetForParameterSection?: string,
    strategies?: Strategy[],
    toolPathId?: number
  ) {
    this.name = name;
    this.description = description;
    this.labledImage = labledImage;
    this.unLabledImage = unLabledImage;
    this.mapMode = mapMode;
    this.operationKey = operationKey;
    this.operationImage = operationImage;
    this.operationName = operationName;
    this.operationToolPathDescription = operationToolPathDescription;
    this.operationToolPathTitle = operationToolPathTitle;
    this.strategies = strategies;
    this.operationImageAssetForParameterSection = operationImageAssetForParameterSection;
    this.toolPathId = toolPathId;
  }
}

export class ToolContainer {
  // defined the types
  public material?: Material_ = undefined;
  public tool?: Cutter_ = undefined;
  public parameters?: Parameters_ = undefined;
  public recommendation?: Recommendation_ = undefined;
  public machine?: Machine_ = undefined;
  public machining?: Machining_ = undefined;
  public hardness?: Hardness = undefined;
  public currenttoolpath?: ToolPath = undefined;
  public recommendationForm?: FormGroup = undefined;
  public hem: Hem_;
  public parametersFields?: number = 0;
  public recommendationFields?: number = 0;
  public dirty?: boolean = false;
  public mapMode: number = 1;
  public displayParamsAndRecs: boolean = true;
  public mapModeTwoValues: ParametersAndRecommendations;
  public hasStrategyOption: boolean = false;
  public currentStrategy?: Strategy = undefined;
  public selectedOperation?: string = undefined;
  constructor(
    hem: Hem_ = new Hem_(),
    material?: Material_,
    tool?: Cutter_,
    parameters?: Parameters_,
    recommendation?: Recommendation_,
    machine?: Machine_,
    machining?: Machining_,
    hardness?: Hardness,
    currenttoolpath?: ToolPath,
    recommendationForm?: FormGroup,
    parametersFields?: number,
    recommendationFields?: number,
    dirty?: boolean,
    mapMode?: number,
    displayParamsAndRecs?: boolean,
    mapModeTwoValues?: ParametersAndRecommendations,
    hasStrategyOption?: boolean,
    currentStrategy?: Strategy,
    selectedOperation?: string
  ) {
    this.hem = hem;
    this.material = material;
    this.tool = tool;
    this.parameters = parameters;
    this.recommendation = recommendation;
    this.machine = machine;
    this.machining = machining;
    this.hardness = hardness;
    this.currenttoolpath = currenttoolpath;
    this.recommendationForm = recommendationForm;
    this.parametersFields = parametersFields;
    this.recommendationFields = recommendationFields;
    this.dirty = dirty;
    this.mapMode = mapMode;
    this.displayParamsAndRecs = displayParamsAndRecs;
    this.mapModeTwoValues = mapModeTwoValues;
    this.hasStrategyOption = hasStrategyOption;
    this.currentStrategy = currentStrategy;
    this.selectedOperation = selectedOperation;
  }
}

export interface Operation_ {
  operation: string;
  toolPaths: ToolPath[];
}

interface ToolPath {
  operationName: string;
  toolPathId: number;
  mapMode: number;
  operationKey: number;
  operationToolPathTitle: string;
  operationToolPathDescription: string;
  operationImage: string;
  operationImageAssetForParameterSection: string;
  strategies: Strategy[];
}

export interface Strategy {
  operationName: string;
  strategyId: number;
  mapMode: number;
  operationKey: number;
  operationImageAssetForParameterSection: string;
}

export interface ParametersAndRecommendations {
  materialKey: number;
  operationKey: number;
  operationHardnessMax: number;
  operationHardnessMin: number;
  parameterHardnessMax: number;
  parameterHardnessMin: number;
  sfmHardnessMax: number;
  sfmHardnessMin: number;
  parameterLabels: ParameterLabel[];
  recommendationLabels: RecommendationLabel[];
}

export interface ParameterLabel {
  parameterValue: string;
  parameterLabel: string;
  parameterHyperlink: string;
}

export interface RecommendationLabel {
  recommendationValue: string;
  recommendationLabel: string;
  recommendationAdjustment: string;
  recommendationPrecision: string;
}

export interface PdfSupportInfo {
  brandKey: number;
  supportName: string;
  supportPhoneNumber: string;
  supportEmail: string;
}

export interface UserDataLoggingInfo {
  userId: string;
  logType: string;
  productKey: number;
  materialId: number;
  HBW: number;
  HBS: number;
  HRB: number;
  HRC: number;
  operationId: number;
  holder: string;
  spindle: string;
  maxRPM: number;
  MaxIPM: number;
  workHoldingSliderPosition: number;
  parameterOneLabel: string;
  parameterOneValue: string;
  parameterTwoLabel: string;
  parameterTwoValue: string;
  parameterThreeLabel: string;
  parameterThreeValue: string;
  parameterFourLabel: string;
  parameterFourValue: string;
  parameterFiveLabel: string;
  parameterFiveValue: string;
  parameterSixLabel: string;
  parameterSixValue: string;
  recommendationOneLabel: string;
  recommendationOneValue: string;
  recommendationTwoLabel: string;
  recommendationTwoValue: string;
  recommendationThreeLabel: string;
  recommendationThreeValue: string;
  recommendationFourLabel: string;
  recommendationFourValue: string;
  recommendationFiveLabel: string;
  recommendationFiveValue: string;
  recommendationSixLabel: string;
  recommendationSixValue: string;
  speedSliderValue: number;
  feedSliderValue: number;
}
